"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hash = void 0;
var serde_1 = require("@smithy/core/serde");
Object.defineProperty(exports, "Hash", { enumerable: true, get: function () { return serde_1.Hash; } });
